import { FC, useState } from 'react';
import { BrightcovePlayer, Theme, FAIcon, IconStyle } from '@nextgen-web-framework/all';
import { ConfigService } from '@nextgen-web-framework/core';
import { useOrientationHook } from '../../../utils';
import { BrightcovePlayerPropsTypes } from './types/propsTypes';
import { SourceTypeEnums } from './types/enums';
import styles from './VideoContainer.module.scss';

const VideoContainer: FC<BrightcovePlayerPropsTypes> = ({
  poster,
  isThumbnail = false,
  className,
  videoId,
  sourceKey,
  ...rest
}: BrightcovePlayerPropsTypes): JSX.Element => {
  const configs = ConfigService.getConfigs();
  const [isPortrait, setIsPortrait] = useState<boolean>(true);

  useOrientationHook((e, isChangeEventAdded = false) => {
    if (isChangeEventAdded) {
      setIsPortrait(!!(e && e.matches));
    }
  });

  return (
    <div
      className={`${styles['cpw-product-video-container']} ${
        isThumbnail ? styles['cpw-product-thumbnail-video'] : ''
      } ${className}`}
      id={`cpw-product-${sourceKey}`}
      data-testid="product-gallery-video-container"
    >
      <BrightcovePlayer
        videoId={videoId}
        playerId={configs?.NEXT_BRIGHT_COVE_PLAYER_ID as string}
        accountId={configs?.NEXT_BRIGHT_COVE_ACC_ID as string}
        poster={poster}
        containerClassName={`${styles['cpw-product-video']} ${
          isPortrait ? styles['cpw-portrait-video'] : styles['cpw-landscape-video']
        }`}
        playOnButtonClick={isThumbnail ? false : true}
        playerHeight={'inherit'}
        {...rest}
      />
      {isThumbnail && (
        <div className={styles['cpw-product-video-play-icon-container']}>
          <FAIcon
            theme={Theme.WHITE}
            iconName={'play'}
            className={styles['cpw-product-video-play-icon']}
            iconStyle={IconStyle.REGULAR}
          />
        </div>
      )}
    </div>
  );
};

export default VideoContainer;
export type { BrightcovePlayerPropsTypes };
export { SourceTypeEnums };
